import { render, staticRenderFns } from "./MainIlustration.vue?vue&type=template&id=c1dee2ee&scoped=true&"
import script from "./MainIlustration.vue?vue&type=script&lang=js&"
export * from "./MainIlustration.vue?vue&type=script&lang=js&"
import style0 from "./MainIlustration.vue?vue&type=style&index=0&id=c1dee2ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1dee2ee",
  null
  
)

component.options.__file = "MainIlustration.vue"
export default component.exports